import config from '@/config/index'

export default {
  baseUrl: `${config.serverURI}`,
  loginUrl: `/login`,
  registerUrl: `/register`,
  logoutUrl: `${config.serverURI}/logout`,
  validateUrl: `${config.serverURI}/validate`,
  tokenName: `access_token`,
  requestDataKey: `data`,
  responseDataKey: `data`,
  bindRequestInterceptor: function () {
    this.$http.interceptors.request.use((config) => {
      if (this.isAuthenticated()) {
        config.headers['Authorization'] = [
          this.options.tokenType, this.getToken()
        ].join(' ')
      } else {
        delete config.headers['Authorization']
      }
      return config
    })
  },
  bindResponseInterceptor: function () {
    this.$http.interceptors.response.use((response) => {
      this.setToken(response)
      return response
    }, error => {
      console.log('Error in bindResponseInterceptor:', error)
      return Promise.reject(error)
    })
  },

  providers: {
  }
}



// WEBPACK FOOTER //
// ./src/config/authenticate.js